export class TreeNode<T extends TreeNode<T>> {
  constructor(public nodes: T[]) {
  }
}
